module.exports = __webpack_public_path__ + "static/media/timelapse_31.8bb6b024.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_31.jpg
// module id = 989
// module chunks = 0